export const generatedCandidateSourceClosurePackets = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-30T00:00:00.000Z",
  "mode": "deterministic-candidate-source-closure-packets",
  "operatingRule": "Candidate source closure packets are executable work instructions. They do not promote source custody, resource composition, or customer use until the referenced evidence gates pass.",
  "asteroidCandidateEvidenceLedgerHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
  "candidateSourcePromotionLedgerHash": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
  "workOrderCount": 10,
  "packetCount": 10,
  "draftIntakePresentCount": 10,
  "missingIntakeArtifactCount": 0,
  "sourceCustodyBlockedCount": 10,
  "resourcePromotionBlockedCount": 10,
  "customerUseBlockedCount": 10,
  "sourceCustodyReady": false,
  "resourcePromotionReady": false,
  "customerUseReady": false,
  "acceptanceGates": {
    "sourceCustodyReadyWhen": "Every candidate closure packet has passed intake with SBDB/CAD/MPC receipts, approved license/terms review, reviewer approval, and validationStatus passed.",
    "resourceReadyWhen": "Every candidate has promoted source custody plus approved taxonomy, spectra, mission, sample, or archive composition evidence.",
    "customerReadyWhen": "Every candidate has resource promotion plus approved source-use clearance for customer-facing packages."
  },
  "packets": [
    {
      "id": "candidate-source-closure-packet-2026-jm2",
      "workOrderId": "small-body-source-work-order-2026-jm2",
      "sourceCandidateId": "cad-2026 JM2",
      "designation": "2026 JM2",
      "name": "2026 JM2",
      "queueRank": 1,
      "reviewPriorityScore": 52.39,
      "intakeState": "draft-intake-present-fail-closed",
      "reportPath": "evidence/source-candidate-work-order-reports/generated-candidate-source-draft-intake-report.json",
      "reportHash": "sha256-bd6988c6a71db8619b5759afd545748da7cfe8749e4e0f0132fd091131f16d27",
      "validationHash": "sha256-1949536a416eac109189615a5e82459a4578b5a493dcd615e1413e50c32858a1",
      "promotionRecordHash": "sha256-46d6875387a397e4cc3109254195b46c3f151612ca4795a97356e06e669c85c4",
      "currentBlockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "querySourceGaps": [
        "mpc"
      ],
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-jm2-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "requiredClosureItems": [
        {
          "id": "mpc-observation-bridge",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "mpc-observation-designation-bridge-receipt",
          "title": "Attach MPC observation/designation bridge receipt",
          "acceptanceCriteria": [
            "Capture the MPC query URL or file path, timestamp, normalized designation bridge, raw hash, normalized hash, units, and parser version.",
            "The candidate source validation fieldCoverage.querySourceGaps must no longer include mpc.",
            "The receipt must be legally reviewable and linked to the exact candidate work order."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jm2-source-intake-report.json evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json",
          "promotionBoundary": "MPC bridge custody can help source-custody promotion only; it is not taxonomy, spectra, resource-composition, or customer-use proof.",
          "closureItemHash": "sha256-27ed506353fa24d5431635d512ed55cb2d204b51825c36d957d03a8494edbe63"
        },
        {
          "id": "license-or-terms-review",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "source-license-terms-review",
          "title": "Approve source license and terms review",
          "acceptanceCriteria": [
            "Record license/terms source URL, capture timestamp, allowed internal use, redistribution boundary, citation requirement, and reviewer identity.",
            "The candidate source validation blockers must not include an unapproved license or terms review.",
            "The review must explicitly preserve provider-endorsement and customer-report boundaries."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jm2-source-intake-report.json evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json",
          "promotionBoundary": "License approval is a custody/legal gate; it does not promote physics, composition, or economics claims.",
          "closureItemHash": "sha256-2a3ef27520e303a54a66a34c836def37d75ea79a461eb3a8a9abd5b1850eb14c"
        },
        {
          "id": "candidate-source-reviewer-approval",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "human-reviewer-approval",
          "title": "Approve candidate source review",
          "acceptanceCriteria": [
            "A named reviewer approves the candidate source packet after checking query receipts, hashes, units, timestamps, source-use notes, and candidate identity.",
            "The candidate source validation blockers must not include reviewer approval.",
            "Approval must be scoped to source custody unless composition and customer-use evidence are separately attached."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jm2-source-intake-report.json evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json",
          "promotionBoundary": "Reviewer approval can promote source custody only when all source-custody fields pass; resource and customer-use gates remain separate.",
          "closureItemHash": "sha256-85b1deb6c916e108b317a6ca2405617c2f6b9d752c9c2202dc30b32f7c64bb4c"
        },
        {
          "id": "passed-validation-status",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-source-validation-status",
          "title": "Set validation status to passed only after evidence closure",
          "acceptanceCriteria": [
            "validationStatus must be passed only after required fields, MPC bridge, license review, and reviewer approval are complete.",
            "The generated candidate source promotion ledger must show this work order as sourceCustodyPromotionAllowed.",
            "The promotion record must include a sha256 promotionRecordHash."
          ],
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Passed validation status is not a shortcut; it is accepted only after source-custody evidence and reviewer gates close.",
          "closureItemHash": "sha256-10997988aee7cede2d0cbd9f8a9ad8c2c0b7b9691e3f159aed7264083c2e042c"
        },
        {
          "id": "taxonomy-spectra-or-mission-archive-composition-evidence",
          "gate": "resource-promotion",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-composition-evidence",
          "title": "Attach candidate-specific composition evidence",
          "acceptanceCriteria": [
            "Attach taxonomy, spectra, mission, sample, or archive evidence tied to the candidate or record an explicit no-evidence-found receipt.",
            "Record source, query, timestamp, license, uncertainty, method directness, and hash metadata.",
            "Resource promotion must remain false unless composition evidence is source-backed and reviewer approved."
          ],
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Composition evidence is required before resource or feedstock claims; source custody alone cannot promote resource claims.",
          "closureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43"
        },
        {
          "id": "source-use-clearance",
          "gate": "customer-use",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-source-use-clearance",
          "title": "Approve customer/report source-use clearance",
          "acceptanceCriteria": [
            "Record whether each attached source can be used in customer reports, exported artifacts, screenshots, and investor/research packages.",
            "Capture citation text, redistribution limits, commercial-use boundary, and reviewer approval.",
            "Customer use must remain blocked until this clearance is approved."
          ],
          "verificationCommand": "npm run science:source:clearance && npm run science:packages",
          "promotionBoundary": "Customer source-use clearance affects report eligibility only; it does not validate scientific or engineering claims.",
          "closureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18"
        }
      ],
      "acceptanceGates": {
        "sourceCustodyReadyWhen": "SBDB, CAD, and MPC receipts are attached; required fields are complete; license/terms review is approved; reviewer approval is approved; validationStatus is passed.",
        "resourceReadyWhen": "Source custody is promoted and candidate-specific taxonomy, spectra, mission, sample, or archive composition evidence is approved.",
        "customerReadyWhen": "Resource promotion is complete and source-use clearance permits the candidate evidence in customer-facing report packages."
      },
      "nextCommandSequence": [
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jm2-source-intake-report.json evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:report"
      ],
      "promotionBoundary": "This packet is a deterministic closure work instruction. It is not source custody, not resource evidence, not customer-use clearance, and not a verified science claim.",
      "packetHash": "sha256-b8c9884921e96895d07fd3d092019180bf1216464d394737fc23d9ae2d95fa08"
    },
    {
      "id": "candidate-source-closure-packet-2026-em",
      "workOrderId": "small-body-source-work-order-2026-em",
      "sourceCandidateId": "cad-2026 EM",
      "designation": "2026 EM",
      "name": "2026 EM",
      "queueRank": 2,
      "reviewPriorityScore": 44.28,
      "intakeState": "draft-intake-present-fail-closed",
      "reportPath": "evidence/source-candidate-work-order-reports/generated-candidate-source-draft-intake-report.json",
      "reportHash": "sha256-bd6988c6a71db8619b5759afd545748da7cfe8749e4e0f0132fd091131f16d27",
      "validationHash": "sha256-ae076bcc8860aadf806b0247a3f36aec296ac911a8e5ab79e333e62a5b55c57c",
      "promotionRecordHash": "sha256-2efa6cfa2d3d32da477f385f4523e3529eea23be1bd1c97f7d437907ec289476",
      "currentBlockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "querySourceGaps": [
        "mpc"
      ],
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-em-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-em-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "requiredClosureItems": [
        {
          "id": "mpc-observation-bridge",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "mpc-observation-designation-bridge-receipt",
          "title": "Attach MPC observation/designation bridge receipt",
          "acceptanceCriteria": [
            "Capture the MPC query URL or file path, timestamp, normalized designation bridge, raw hash, normalized hash, units, and parser version.",
            "The candidate source validation fieldCoverage.querySourceGaps must no longer include mpc.",
            "The receipt must be legally reviewable and linked to the exact candidate work order."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-em-source-intake-report.json evidence/source-candidate-payloads/2026-em-source-intake-payload.json",
          "promotionBoundary": "MPC bridge custody can help source-custody promotion only; it is not taxonomy, spectra, resource-composition, or customer-use proof.",
          "closureItemHash": "sha256-8fa7d9008b5a7837c04c6fec992be3caa2fa11b38592f6d7f351afadae1d3c9e"
        },
        {
          "id": "license-or-terms-review",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "source-license-terms-review",
          "title": "Approve source license and terms review",
          "acceptanceCriteria": [
            "Record license/terms source URL, capture timestamp, allowed internal use, redistribution boundary, citation requirement, and reviewer identity.",
            "The candidate source validation blockers must not include an unapproved license or terms review.",
            "The review must explicitly preserve provider-endorsement and customer-report boundaries."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-em-source-intake-report.json evidence/source-candidate-payloads/2026-em-source-intake-payload.json",
          "promotionBoundary": "License approval is a custody/legal gate; it does not promote physics, composition, or economics claims.",
          "closureItemHash": "sha256-c98de17107649e4f49f61200ec32e76562a3084e0d325b30510244c68c90b4b7"
        },
        {
          "id": "candidate-source-reviewer-approval",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "human-reviewer-approval",
          "title": "Approve candidate source review",
          "acceptanceCriteria": [
            "A named reviewer approves the candidate source packet after checking query receipts, hashes, units, timestamps, source-use notes, and candidate identity.",
            "The candidate source validation blockers must not include reviewer approval.",
            "Approval must be scoped to source custody unless composition and customer-use evidence are separately attached."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-em-source-intake-report.json evidence/source-candidate-payloads/2026-em-source-intake-payload.json",
          "promotionBoundary": "Reviewer approval can promote source custody only when all source-custody fields pass; resource and customer-use gates remain separate.",
          "closureItemHash": "sha256-641a96ebaba165d05af9298890558bb4085b38f30e739fb84b582d1a9c39785e"
        },
        {
          "id": "passed-validation-status",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-source-validation-status",
          "title": "Set validation status to passed only after evidence closure",
          "acceptanceCriteria": [
            "validationStatus must be passed only after required fields, MPC bridge, license review, and reviewer approval are complete.",
            "The generated candidate source promotion ledger must show this work order as sourceCustodyPromotionAllowed.",
            "The promotion record must include a sha256 promotionRecordHash."
          ],
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Passed validation status is not a shortcut; it is accepted only after source-custody evidence and reviewer gates close.",
          "closureItemHash": "sha256-10997988aee7cede2d0cbd9f8a9ad8c2c0b7b9691e3f159aed7264083c2e042c"
        },
        {
          "id": "taxonomy-spectra-or-mission-archive-composition-evidence",
          "gate": "resource-promotion",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-composition-evidence",
          "title": "Attach candidate-specific composition evidence",
          "acceptanceCriteria": [
            "Attach taxonomy, spectra, mission, sample, or archive evidence tied to the candidate or record an explicit no-evidence-found receipt.",
            "Record source, query, timestamp, license, uncertainty, method directness, and hash metadata.",
            "Resource promotion must remain false unless composition evidence is source-backed and reviewer approved."
          ],
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Composition evidence is required before resource or feedstock claims; source custody alone cannot promote resource claims.",
          "closureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43"
        },
        {
          "id": "source-use-clearance",
          "gate": "customer-use",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-source-use-clearance",
          "title": "Approve customer/report source-use clearance",
          "acceptanceCriteria": [
            "Record whether each attached source can be used in customer reports, exported artifacts, screenshots, and investor/research packages.",
            "Capture citation text, redistribution limits, commercial-use boundary, and reviewer approval.",
            "Customer use must remain blocked until this clearance is approved."
          ],
          "verificationCommand": "npm run science:source:clearance && npm run science:packages",
          "promotionBoundary": "Customer source-use clearance affects report eligibility only; it does not validate scientific or engineering claims.",
          "closureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18"
        }
      ],
      "acceptanceGates": {
        "sourceCustodyReadyWhen": "SBDB, CAD, and MPC receipts are attached; required fields are complete; license/terms review is approved; reviewer approval is approved; validationStatus is passed.",
        "resourceReadyWhen": "Source custody is promoted and candidate-specific taxonomy, spectra, mission, sample, or archive composition evidence is approved.",
        "customerReadyWhen": "Resource promotion is complete and source-use clearance permits the candidate evidence in customer-facing report packages."
      },
      "nextCommandSequence": [
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-em-source-intake-report.json evidence/source-candidate-payloads/2026-em-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:report"
      ],
      "promotionBoundary": "This packet is a deterministic closure work instruction. It is not source custody, not resource evidence, not customer-use clearance, and not a verified science claim.",
      "packetHash": "sha256-5fe6fb4a6dbb2dab31c843b41f2f8ea0bf38970f6b37602b3057f57ec166f476"
    },
    {
      "id": "candidate-source-closure-packet-2026-dn5",
      "workOrderId": "small-body-source-work-order-2026-dn5",
      "sourceCandidateId": "cad-2026 DN5",
      "designation": "2026 DN5",
      "name": "2026 DN5",
      "queueRank": 3,
      "reviewPriorityScore": 39.5,
      "intakeState": "draft-intake-present-fail-closed",
      "reportPath": "evidence/source-candidate-work-order-reports/generated-candidate-source-draft-intake-report.json",
      "reportHash": "sha256-bd6988c6a71db8619b5759afd545748da7cfe8749e4e0f0132fd091131f16d27",
      "validationHash": "sha256-c5231a7b83457b1c08c90f9c3f355ed338e4849911a819b3ad1200ce1577fd56",
      "promotionRecordHash": "sha256-a3d3a5f26dae62fbfc68c69f1890c449d1aa53f3926562bfc43e9722ee09f6b5",
      "currentBlockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "querySourceGaps": [
        "mpc"
      ],
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-dn5-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "requiredClosureItems": [
        {
          "id": "mpc-observation-bridge",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "mpc-observation-designation-bridge-receipt",
          "title": "Attach MPC observation/designation bridge receipt",
          "acceptanceCriteria": [
            "Capture the MPC query URL or file path, timestamp, normalized designation bridge, raw hash, normalized hash, units, and parser version.",
            "The candidate source validation fieldCoverage.querySourceGaps must no longer include mpc.",
            "The receipt must be legally reviewable and linked to the exact candidate work order."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-dn5-source-intake-report.json evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json",
          "promotionBoundary": "MPC bridge custody can help source-custody promotion only; it is not taxonomy, spectra, resource-composition, or customer-use proof.",
          "closureItemHash": "sha256-b61f18a3e0de39e173cb0198832f78de8eec280557ef4fd9142ad55d182277cf"
        },
        {
          "id": "license-or-terms-review",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "source-license-terms-review",
          "title": "Approve source license and terms review",
          "acceptanceCriteria": [
            "Record license/terms source URL, capture timestamp, allowed internal use, redistribution boundary, citation requirement, and reviewer identity.",
            "The candidate source validation blockers must not include an unapproved license or terms review.",
            "The review must explicitly preserve provider-endorsement and customer-report boundaries."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-dn5-source-intake-report.json evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json",
          "promotionBoundary": "License approval is a custody/legal gate; it does not promote physics, composition, or economics claims.",
          "closureItemHash": "sha256-90d677de7decc07ae526b7fd89e72ccac8ea2b183f1d018a0f183c9c80249392"
        },
        {
          "id": "candidate-source-reviewer-approval",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "human-reviewer-approval",
          "title": "Approve candidate source review",
          "acceptanceCriteria": [
            "A named reviewer approves the candidate source packet after checking query receipts, hashes, units, timestamps, source-use notes, and candidate identity.",
            "The candidate source validation blockers must not include reviewer approval.",
            "Approval must be scoped to source custody unless composition and customer-use evidence are separately attached."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-dn5-source-intake-report.json evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json",
          "promotionBoundary": "Reviewer approval can promote source custody only when all source-custody fields pass; resource and customer-use gates remain separate.",
          "closureItemHash": "sha256-27e7bb81f1c4d022e92bfd382905dd753e4ea9c5ed2fd397e0b97562ee375f47"
        },
        {
          "id": "passed-validation-status",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-source-validation-status",
          "title": "Set validation status to passed only after evidence closure",
          "acceptanceCriteria": [
            "validationStatus must be passed only after required fields, MPC bridge, license review, and reviewer approval are complete.",
            "The generated candidate source promotion ledger must show this work order as sourceCustodyPromotionAllowed.",
            "The promotion record must include a sha256 promotionRecordHash."
          ],
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Passed validation status is not a shortcut; it is accepted only after source-custody evidence and reviewer gates close.",
          "closureItemHash": "sha256-10997988aee7cede2d0cbd9f8a9ad8c2c0b7b9691e3f159aed7264083c2e042c"
        },
        {
          "id": "taxonomy-spectra-or-mission-archive-composition-evidence",
          "gate": "resource-promotion",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-composition-evidence",
          "title": "Attach candidate-specific composition evidence",
          "acceptanceCriteria": [
            "Attach taxonomy, spectra, mission, sample, or archive evidence tied to the candidate or record an explicit no-evidence-found receipt.",
            "Record source, query, timestamp, license, uncertainty, method directness, and hash metadata.",
            "Resource promotion must remain false unless composition evidence is source-backed and reviewer approved."
          ],
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Composition evidence is required before resource or feedstock claims; source custody alone cannot promote resource claims.",
          "closureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43"
        },
        {
          "id": "source-use-clearance",
          "gate": "customer-use",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-source-use-clearance",
          "title": "Approve customer/report source-use clearance",
          "acceptanceCriteria": [
            "Record whether each attached source can be used in customer reports, exported artifacts, screenshots, and investor/research packages.",
            "Capture citation text, redistribution limits, commercial-use boundary, and reviewer approval.",
            "Customer use must remain blocked until this clearance is approved."
          ],
          "verificationCommand": "npm run science:source:clearance && npm run science:packages",
          "promotionBoundary": "Customer source-use clearance affects report eligibility only; it does not validate scientific or engineering claims.",
          "closureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18"
        }
      ],
      "acceptanceGates": {
        "sourceCustodyReadyWhen": "SBDB, CAD, and MPC receipts are attached; required fields are complete; license/terms review is approved; reviewer approval is approved; validationStatus is passed.",
        "resourceReadyWhen": "Source custody is promoted and candidate-specific taxonomy, spectra, mission, sample, or archive composition evidence is approved.",
        "customerReadyWhen": "Resource promotion is complete and source-use clearance permits the candidate evidence in customer-facing report packages."
      },
      "nextCommandSequence": [
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-dn5-source-intake-report.json evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:report"
      ],
      "promotionBoundary": "This packet is a deterministic closure work instruction. It is not source custody, not resource evidence, not customer-use clearance, and not a verified science claim.",
      "packetHash": "sha256-1f658a0d55749a22f8502fb8da9afc75587853bf55d17d44a1b27c8f151ad35e"
    },
    {
      "id": "candidate-source-closure-packet-2026-lx",
      "workOrderId": "small-body-source-work-order-2026-lx",
      "sourceCandidateId": "cad-2026 LX",
      "designation": "2026 LX",
      "name": "2026 LX",
      "queueRank": 4,
      "reviewPriorityScore": 39.44,
      "intakeState": "draft-intake-present-fail-closed",
      "reportPath": "evidence/source-candidate-work-order-reports/generated-candidate-source-draft-intake-report.json",
      "reportHash": "sha256-bd6988c6a71db8619b5759afd545748da7cfe8749e4e0f0132fd091131f16d27",
      "validationHash": "sha256-c4cc553e48bf9022706358b6c76ba76ad460d76fe0ebbdebb6e0b3fc304cca14",
      "promotionRecordHash": "sha256-52bbe5bc6c5e958f702d811e0fce3dae217f832fb8d428cdcaababae8b4a953b",
      "currentBlockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "querySourceGaps": [
        "mpc"
      ],
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-lx-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-lx-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "requiredClosureItems": [
        {
          "id": "mpc-observation-bridge",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "mpc-observation-designation-bridge-receipt",
          "title": "Attach MPC observation/designation bridge receipt",
          "acceptanceCriteria": [
            "Capture the MPC query URL or file path, timestamp, normalized designation bridge, raw hash, normalized hash, units, and parser version.",
            "The candidate source validation fieldCoverage.querySourceGaps must no longer include mpc.",
            "The receipt must be legally reviewable and linked to the exact candidate work order."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-lx-source-intake-report.json evidence/source-candidate-payloads/2026-lx-source-intake-payload.json",
          "promotionBoundary": "MPC bridge custody can help source-custody promotion only; it is not taxonomy, spectra, resource-composition, or customer-use proof.",
          "closureItemHash": "sha256-dacf600fd5410f655e246f540fa78602b373b226d92ace772ae8b06eb9aabecf"
        },
        {
          "id": "license-or-terms-review",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "source-license-terms-review",
          "title": "Approve source license and terms review",
          "acceptanceCriteria": [
            "Record license/terms source URL, capture timestamp, allowed internal use, redistribution boundary, citation requirement, and reviewer identity.",
            "The candidate source validation blockers must not include an unapproved license or terms review.",
            "The review must explicitly preserve provider-endorsement and customer-report boundaries."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-lx-source-intake-report.json evidence/source-candidate-payloads/2026-lx-source-intake-payload.json",
          "promotionBoundary": "License approval is a custody/legal gate; it does not promote physics, composition, or economics claims.",
          "closureItemHash": "sha256-791c15b182a44058b0bd6a6f9bff78f5796724679fbbbf4a0a1fb04fc80c25d2"
        },
        {
          "id": "candidate-source-reviewer-approval",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "human-reviewer-approval",
          "title": "Approve candidate source review",
          "acceptanceCriteria": [
            "A named reviewer approves the candidate source packet after checking query receipts, hashes, units, timestamps, source-use notes, and candidate identity.",
            "The candidate source validation blockers must not include reviewer approval.",
            "Approval must be scoped to source custody unless composition and customer-use evidence are separately attached."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-lx-source-intake-report.json evidence/source-candidate-payloads/2026-lx-source-intake-payload.json",
          "promotionBoundary": "Reviewer approval can promote source custody only when all source-custody fields pass; resource and customer-use gates remain separate.",
          "closureItemHash": "sha256-43977f73714168c73c6eb4b6c769f8d3b5db0ebadb4941ddc51b36afb347c7f5"
        },
        {
          "id": "passed-validation-status",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-source-validation-status",
          "title": "Set validation status to passed only after evidence closure",
          "acceptanceCriteria": [
            "validationStatus must be passed only after required fields, MPC bridge, license review, and reviewer approval are complete.",
            "The generated candidate source promotion ledger must show this work order as sourceCustodyPromotionAllowed.",
            "The promotion record must include a sha256 promotionRecordHash."
          ],
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Passed validation status is not a shortcut; it is accepted only after source-custody evidence and reviewer gates close.",
          "closureItemHash": "sha256-10997988aee7cede2d0cbd9f8a9ad8c2c0b7b9691e3f159aed7264083c2e042c"
        },
        {
          "id": "taxonomy-spectra-or-mission-archive-composition-evidence",
          "gate": "resource-promotion",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-composition-evidence",
          "title": "Attach candidate-specific composition evidence",
          "acceptanceCriteria": [
            "Attach taxonomy, spectra, mission, sample, or archive evidence tied to the candidate or record an explicit no-evidence-found receipt.",
            "Record source, query, timestamp, license, uncertainty, method directness, and hash metadata.",
            "Resource promotion must remain false unless composition evidence is source-backed and reviewer approved."
          ],
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Composition evidence is required before resource or feedstock claims; source custody alone cannot promote resource claims.",
          "closureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43"
        },
        {
          "id": "source-use-clearance",
          "gate": "customer-use",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-source-use-clearance",
          "title": "Approve customer/report source-use clearance",
          "acceptanceCriteria": [
            "Record whether each attached source can be used in customer reports, exported artifacts, screenshots, and investor/research packages.",
            "Capture citation text, redistribution limits, commercial-use boundary, and reviewer approval.",
            "Customer use must remain blocked until this clearance is approved."
          ],
          "verificationCommand": "npm run science:source:clearance && npm run science:packages",
          "promotionBoundary": "Customer source-use clearance affects report eligibility only; it does not validate scientific or engineering claims.",
          "closureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18"
        }
      ],
      "acceptanceGates": {
        "sourceCustodyReadyWhen": "SBDB, CAD, and MPC receipts are attached; required fields are complete; license/terms review is approved; reviewer approval is approved; validationStatus is passed.",
        "resourceReadyWhen": "Source custody is promoted and candidate-specific taxonomy, spectra, mission, sample, or archive composition evidence is approved.",
        "customerReadyWhen": "Resource promotion is complete and source-use clearance permits the candidate evidence in customer-facing report packages."
      },
      "nextCommandSequence": [
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-lx-source-intake-report.json evidence/source-candidate-payloads/2026-lx-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:report"
      ],
      "promotionBoundary": "This packet is a deterministic closure work instruction. It is not source custody, not resource evidence, not customer-use clearance, and not a verified science claim.",
      "packetHash": "sha256-8e023ddbb1663a7f0a13db2d79d2d8a9778517c2ca417d97068361e34ae4b171"
    },
    {
      "id": "candidate-source-closure-packet-2026-ku1",
      "workOrderId": "small-body-source-work-order-2026-ku1",
      "sourceCandidateId": "cad-2026 KU1",
      "designation": "2026 KU1",
      "name": "2026 KU1",
      "queueRank": 5,
      "reviewPriorityScore": 36.59,
      "intakeState": "draft-intake-present-fail-closed",
      "reportPath": "evidence/source-candidate-work-order-reports/generated-candidate-source-draft-intake-report.json",
      "reportHash": "sha256-bd6988c6a71db8619b5759afd545748da7cfe8749e4e0f0132fd091131f16d27",
      "validationHash": "sha256-57da5013b4f952d41c0c96585a2b31da190b0ac51a19e028bfdd78eaebd642cc",
      "promotionRecordHash": "sha256-90108d23ae39cc461b00a8e8d61489adfb5b3b6281e47f85e1c535b84595c8ef",
      "currentBlockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "querySourceGaps": [
        "mpc"
      ],
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-ku1-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-ku1-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "requiredClosureItems": [
        {
          "id": "mpc-observation-bridge",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "mpc-observation-designation-bridge-receipt",
          "title": "Attach MPC observation/designation bridge receipt",
          "acceptanceCriteria": [
            "Capture the MPC query URL or file path, timestamp, normalized designation bridge, raw hash, normalized hash, units, and parser version.",
            "The candidate source validation fieldCoverage.querySourceGaps must no longer include mpc.",
            "The receipt must be legally reviewable and linked to the exact candidate work order."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-ku1-source-intake-report.json evidence/source-candidate-payloads/2026-ku1-source-intake-payload.json",
          "promotionBoundary": "MPC bridge custody can help source-custody promotion only; it is not taxonomy, spectra, resource-composition, or customer-use proof.",
          "closureItemHash": "sha256-c2e4c4d4248ab20ec8644ff79ad7ac1d64e0b92fb7a3efa3063559caabf5f610"
        },
        {
          "id": "license-or-terms-review",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "source-license-terms-review",
          "title": "Approve source license and terms review",
          "acceptanceCriteria": [
            "Record license/terms source URL, capture timestamp, allowed internal use, redistribution boundary, citation requirement, and reviewer identity.",
            "The candidate source validation blockers must not include an unapproved license or terms review.",
            "The review must explicitly preserve provider-endorsement and customer-report boundaries."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-ku1-source-intake-report.json evidence/source-candidate-payloads/2026-ku1-source-intake-payload.json",
          "promotionBoundary": "License approval is a custody/legal gate; it does not promote physics, composition, or economics claims.",
          "closureItemHash": "sha256-acfde7a49e395ff0be48794e2b2ddac86098e3ab74cebe0250cc4779a08dc639"
        },
        {
          "id": "candidate-source-reviewer-approval",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "human-reviewer-approval",
          "title": "Approve candidate source review",
          "acceptanceCriteria": [
            "A named reviewer approves the candidate source packet after checking query receipts, hashes, units, timestamps, source-use notes, and candidate identity.",
            "The candidate source validation blockers must not include reviewer approval.",
            "Approval must be scoped to source custody unless composition and customer-use evidence are separately attached."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-ku1-source-intake-report.json evidence/source-candidate-payloads/2026-ku1-source-intake-payload.json",
          "promotionBoundary": "Reviewer approval can promote source custody only when all source-custody fields pass; resource and customer-use gates remain separate.",
          "closureItemHash": "sha256-482e7e2e661bee68b01559f1590d08e752455ae900336262f0811b1bee82286b"
        },
        {
          "id": "passed-validation-status",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-source-validation-status",
          "title": "Set validation status to passed only after evidence closure",
          "acceptanceCriteria": [
            "validationStatus must be passed only after required fields, MPC bridge, license review, and reviewer approval are complete.",
            "The generated candidate source promotion ledger must show this work order as sourceCustodyPromotionAllowed.",
            "The promotion record must include a sha256 promotionRecordHash."
          ],
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Passed validation status is not a shortcut; it is accepted only after source-custody evidence and reviewer gates close.",
          "closureItemHash": "sha256-10997988aee7cede2d0cbd9f8a9ad8c2c0b7b9691e3f159aed7264083c2e042c"
        },
        {
          "id": "taxonomy-spectra-or-mission-archive-composition-evidence",
          "gate": "resource-promotion",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-composition-evidence",
          "title": "Attach candidate-specific composition evidence",
          "acceptanceCriteria": [
            "Attach taxonomy, spectra, mission, sample, or archive evidence tied to the candidate or record an explicit no-evidence-found receipt.",
            "Record source, query, timestamp, license, uncertainty, method directness, and hash metadata.",
            "Resource promotion must remain false unless composition evidence is source-backed and reviewer approved."
          ],
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Composition evidence is required before resource or feedstock claims; source custody alone cannot promote resource claims.",
          "closureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43"
        },
        {
          "id": "source-use-clearance",
          "gate": "customer-use",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-source-use-clearance",
          "title": "Approve customer/report source-use clearance",
          "acceptanceCriteria": [
            "Record whether each attached source can be used in customer reports, exported artifacts, screenshots, and investor/research packages.",
            "Capture citation text, redistribution limits, commercial-use boundary, and reviewer approval.",
            "Customer use must remain blocked until this clearance is approved."
          ],
          "verificationCommand": "npm run science:source:clearance && npm run science:packages",
          "promotionBoundary": "Customer source-use clearance affects report eligibility only; it does not validate scientific or engineering claims.",
          "closureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18"
        }
      ],
      "acceptanceGates": {
        "sourceCustodyReadyWhen": "SBDB, CAD, and MPC receipts are attached; required fields are complete; license/terms review is approved; reviewer approval is approved; validationStatus is passed.",
        "resourceReadyWhen": "Source custody is promoted and candidate-specific taxonomy, spectra, mission, sample, or archive composition evidence is approved.",
        "customerReadyWhen": "Resource promotion is complete and source-use clearance permits the candidate evidence in customer-facing report packages."
      },
      "nextCommandSequence": [
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-ku1-source-intake-report.json evidence/source-candidate-payloads/2026-ku1-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:report"
      ],
      "promotionBoundary": "This packet is a deterministic closure work instruction. It is not source custody, not resource evidence, not customer-use clearance, and not a verified science claim.",
      "packetHash": "sha256-a717d87ca9fe0b2d21044b443a4a2c75b8f858a4dac5746506dc16d78074e4a0"
    },
    {
      "id": "candidate-source-closure-packet-2026-fs5",
      "workOrderId": "small-body-source-work-order-2026-fs5",
      "sourceCandidateId": "cad-2026 FS5",
      "designation": "2026 FS5",
      "name": "2026 FS5",
      "queueRank": 6,
      "reviewPriorityScore": 30.19,
      "intakeState": "draft-intake-present-fail-closed",
      "reportPath": "evidence/source-candidate-work-order-reports/generated-candidate-source-draft-intake-report.json",
      "reportHash": "sha256-bd6988c6a71db8619b5759afd545748da7cfe8749e4e0f0132fd091131f16d27",
      "validationHash": "sha256-e144c6664c596e146d4ba694672b68ca573e27d263f8e1ed03e6c3bf73bdfdf4",
      "promotionRecordHash": "sha256-3748d160ef42acb832d450aff7e9dcecdf4eaf358125ca518d4f4560b6b7b41c",
      "currentBlockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "querySourceGaps": [
        "mpc"
      ],
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-fs5-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-fs5-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "requiredClosureItems": [
        {
          "id": "mpc-observation-bridge",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "mpc-observation-designation-bridge-receipt",
          "title": "Attach MPC observation/designation bridge receipt",
          "acceptanceCriteria": [
            "Capture the MPC query URL or file path, timestamp, normalized designation bridge, raw hash, normalized hash, units, and parser version.",
            "The candidate source validation fieldCoverage.querySourceGaps must no longer include mpc.",
            "The receipt must be legally reviewable and linked to the exact candidate work order."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-fs5-source-intake-report.json evidence/source-candidate-payloads/2026-fs5-source-intake-payload.json",
          "promotionBoundary": "MPC bridge custody can help source-custody promotion only; it is not taxonomy, spectra, resource-composition, or customer-use proof.",
          "closureItemHash": "sha256-820ada4336a2f59c4b5158388e70a8bd16e66f14c6e2fe5467cf6a948307f64b"
        },
        {
          "id": "license-or-terms-review",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "source-license-terms-review",
          "title": "Approve source license and terms review",
          "acceptanceCriteria": [
            "Record license/terms source URL, capture timestamp, allowed internal use, redistribution boundary, citation requirement, and reviewer identity.",
            "The candidate source validation blockers must not include an unapproved license or terms review.",
            "The review must explicitly preserve provider-endorsement and customer-report boundaries."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-fs5-source-intake-report.json evidence/source-candidate-payloads/2026-fs5-source-intake-payload.json",
          "promotionBoundary": "License approval is a custody/legal gate; it does not promote physics, composition, or economics claims.",
          "closureItemHash": "sha256-0ed2f45d6f34fb58d626b10e94737add155f70628356638e8b422c9316c39cd2"
        },
        {
          "id": "candidate-source-reviewer-approval",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "human-reviewer-approval",
          "title": "Approve candidate source review",
          "acceptanceCriteria": [
            "A named reviewer approves the candidate source packet after checking query receipts, hashes, units, timestamps, source-use notes, and candidate identity.",
            "The candidate source validation blockers must not include reviewer approval.",
            "Approval must be scoped to source custody unless composition and customer-use evidence are separately attached."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-fs5-source-intake-report.json evidence/source-candidate-payloads/2026-fs5-source-intake-payload.json",
          "promotionBoundary": "Reviewer approval can promote source custody only when all source-custody fields pass; resource and customer-use gates remain separate.",
          "closureItemHash": "sha256-0463eea4ab6511dc755137855a34291943e7ba9753397c0eef74878aa0865cdf"
        },
        {
          "id": "passed-validation-status",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-source-validation-status",
          "title": "Set validation status to passed only after evidence closure",
          "acceptanceCriteria": [
            "validationStatus must be passed only after required fields, MPC bridge, license review, and reviewer approval are complete.",
            "The generated candidate source promotion ledger must show this work order as sourceCustodyPromotionAllowed.",
            "The promotion record must include a sha256 promotionRecordHash."
          ],
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Passed validation status is not a shortcut; it is accepted only after source-custody evidence and reviewer gates close.",
          "closureItemHash": "sha256-10997988aee7cede2d0cbd9f8a9ad8c2c0b7b9691e3f159aed7264083c2e042c"
        },
        {
          "id": "taxonomy-spectra-or-mission-archive-composition-evidence",
          "gate": "resource-promotion",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-composition-evidence",
          "title": "Attach candidate-specific composition evidence",
          "acceptanceCriteria": [
            "Attach taxonomy, spectra, mission, sample, or archive evidence tied to the candidate or record an explicit no-evidence-found receipt.",
            "Record source, query, timestamp, license, uncertainty, method directness, and hash metadata.",
            "Resource promotion must remain false unless composition evidence is source-backed and reviewer approved."
          ],
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Composition evidence is required before resource or feedstock claims; source custody alone cannot promote resource claims.",
          "closureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43"
        },
        {
          "id": "source-use-clearance",
          "gate": "customer-use",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-source-use-clearance",
          "title": "Approve customer/report source-use clearance",
          "acceptanceCriteria": [
            "Record whether each attached source can be used in customer reports, exported artifacts, screenshots, and investor/research packages.",
            "Capture citation text, redistribution limits, commercial-use boundary, and reviewer approval.",
            "Customer use must remain blocked until this clearance is approved."
          ],
          "verificationCommand": "npm run science:source:clearance && npm run science:packages",
          "promotionBoundary": "Customer source-use clearance affects report eligibility only; it does not validate scientific or engineering claims.",
          "closureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18"
        }
      ],
      "acceptanceGates": {
        "sourceCustodyReadyWhen": "SBDB, CAD, and MPC receipts are attached; required fields are complete; license/terms review is approved; reviewer approval is approved; validationStatus is passed.",
        "resourceReadyWhen": "Source custody is promoted and candidate-specific taxonomy, spectra, mission, sample, or archive composition evidence is approved.",
        "customerReadyWhen": "Resource promotion is complete and source-use clearance permits the candidate evidence in customer-facing report packages."
      },
      "nextCommandSequence": [
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-fs5-source-intake-report.json evidence/source-candidate-payloads/2026-fs5-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:report"
      ],
      "promotionBoundary": "This packet is a deterministic closure work instruction. It is not source custody, not resource evidence, not customer-use clearance, and not a verified science claim.",
      "packetHash": "sha256-59f5b1dbd44428ab2fc9136eb918bf832aa498d1720e7caebc2e6724044512c5"
    },
    {
      "id": "candidate-source-closure-packet-2026-et3",
      "workOrderId": "small-body-source-work-order-2026-et3",
      "sourceCandidateId": "cad-2026 ET3",
      "designation": "2026 ET3",
      "name": "2026 ET3",
      "queueRank": 7,
      "reviewPriorityScore": 25.97,
      "intakeState": "draft-intake-present-fail-closed",
      "reportPath": "evidence/source-candidate-work-order-reports/generated-candidate-source-draft-intake-report.json",
      "reportHash": "sha256-bd6988c6a71db8619b5759afd545748da7cfe8749e4e0f0132fd091131f16d27",
      "validationHash": "sha256-e0f70405482c25988361bdc52da4350a233a2ed22a5b0967ef22c73e084ed65b",
      "promotionRecordHash": "sha256-0b0f31ddd1e7d0dc92b0c1b1ba8c854abb669e25083b60a9ee8469a31c858509",
      "currentBlockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "querySourceGaps": [
        "mpc"
      ],
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-et3-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-et3-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "requiredClosureItems": [
        {
          "id": "mpc-observation-bridge",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "mpc-observation-designation-bridge-receipt",
          "title": "Attach MPC observation/designation bridge receipt",
          "acceptanceCriteria": [
            "Capture the MPC query URL or file path, timestamp, normalized designation bridge, raw hash, normalized hash, units, and parser version.",
            "The candidate source validation fieldCoverage.querySourceGaps must no longer include mpc.",
            "The receipt must be legally reviewable and linked to the exact candidate work order."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-et3-source-intake-report.json evidence/source-candidate-payloads/2026-et3-source-intake-payload.json",
          "promotionBoundary": "MPC bridge custody can help source-custody promotion only; it is not taxonomy, spectra, resource-composition, or customer-use proof.",
          "closureItemHash": "sha256-96db53717bea6d2a65f6663b5c0559776e5a46bdddaca7823a45e2bc6ca2b129"
        },
        {
          "id": "license-or-terms-review",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "source-license-terms-review",
          "title": "Approve source license and terms review",
          "acceptanceCriteria": [
            "Record license/terms source URL, capture timestamp, allowed internal use, redistribution boundary, citation requirement, and reviewer identity.",
            "The candidate source validation blockers must not include an unapproved license or terms review.",
            "The review must explicitly preserve provider-endorsement and customer-report boundaries."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-et3-source-intake-report.json evidence/source-candidate-payloads/2026-et3-source-intake-payload.json",
          "promotionBoundary": "License approval is a custody/legal gate; it does not promote physics, composition, or economics claims.",
          "closureItemHash": "sha256-7e13e4699144544dde5babb4d781307442cf89bf58ff4b56a92b9712d6f70d81"
        },
        {
          "id": "candidate-source-reviewer-approval",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "human-reviewer-approval",
          "title": "Approve candidate source review",
          "acceptanceCriteria": [
            "A named reviewer approves the candidate source packet after checking query receipts, hashes, units, timestamps, source-use notes, and candidate identity.",
            "The candidate source validation blockers must not include reviewer approval.",
            "Approval must be scoped to source custody unless composition and customer-use evidence are separately attached."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-et3-source-intake-report.json evidence/source-candidate-payloads/2026-et3-source-intake-payload.json",
          "promotionBoundary": "Reviewer approval can promote source custody only when all source-custody fields pass; resource and customer-use gates remain separate.",
          "closureItemHash": "sha256-6ecfcbd8a53e323cfc45f68b85ed73d2b05fbbe3b4fad478797fcedf04bd2d62"
        },
        {
          "id": "passed-validation-status",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-source-validation-status",
          "title": "Set validation status to passed only after evidence closure",
          "acceptanceCriteria": [
            "validationStatus must be passed only after required fields, MPC bridge, license review, and reviewer approval are complete.",
            "The generated candidate source promotion ledger must show this work order as sourceCustodyPromotionAllowed.",
            "The promotion record must include a sha256 promotionRecordHash."
          ],
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Passed validation status is not a shortcut; it is accepted only after source-custody evidence and reviewer gates close.",
          "closureItemHash": "sha256-10997988aee7cede2d0cbd9f8a9ad8c2c0b7b9691e3f159aed7264083c2e042c"
        },
        {
          "id": "taxonomy-spectra-or-mission-archive-composition-evidence",
          "gate": "resource-promotion",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-composition-evidence",
          "title": "Attach candidate-specific composition evidence",
          "acceptanceCriteria": [
            "Attach taxonomy, spectra, mission, sample, or archive evidence tied to the candidate or record an explicit no-evidence-found receipt.",
            "Record source, query, timestamp, license, uncertainty, method directness, and hash metadata.",
            "Resource promotion must remain false unless composition evidence is source-backed and reviewer approved."
          ],
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Composition evidence is required before resource or feedstock claims; source custody alone cannot promote resource claims.",
          "closureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43"
        },
        {
          "id": "source-use-clearance",
          "gate": "customer-use",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-source-use-clearance",
          "title": "Approve customer/report source-use clearance",
          "acceptanceCriteria": [
            "Record whether each attached source can be used in customer reports, exported artifacts, screenshots, and investor/research packages.",
            "Capture citation text, redistribution limits, commercial-use boundary, and reviewer approval.",
            "Customer use must remain blocked until this clearance is approved."
          ],
          "verificationCommand": "npm run science:source:clearance && npm run science:packages",
          "promotionBoundary": "Customer source-use clearance affects report eligibility only; it does not validate scientific or engineering claims.",
          "closureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18"
        }
      ],
      "acceptanceGates": {
        "sourceCustodyReadyWhen": "SBDB, CAD, and MPC receipts are attached; required fields are complete; license/terms review is approved; reviewer approval is approved; validationStatus is passed.",
        "resourceReadyWhen": "Source custody is promoted and candidate-specific taxonomy, spectra, mission, sample, or archive composition evidence is approved.",
        "customerReadyWhen": "Resource promotion is complete and source-use clearance permits the candidate evidence in customer-facing report packages."
      },
      "nextCommandSequence": [
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-et3-source-intake-report.json evidence/source-candidate-payloads/2026-et3-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:report"
      ],
      "promotionBoundary": "This packet is a deterministic closure work instruction. It is not source custody, not resource evidence, not customer-use clearance, and not a verified science claim.",
      "packetHash": "sha256-09986b83f9409f52af4e880c7fc9936888f8c4817dc3fe7cf1ea163c5f09b44a"
    },
    {
      "id": "candidate-source-closure-packet-2026-jn4",
      "workOrderId": "small-body-source-work-order-2026-jn4",
      "sourceCandidateId": "cad-2026 JN4",
      "designation": "2026 JN4",
      "name": "2026 JN4",
      "queueRank": 8,
      "reviewPriorityScore": 24.65,
      "intakeState": "draft-intake-present-fail-closed",
      "reportPath": "evidence/source-candidate-work-order-reports/generated-candidate-source-draft-intake-report.json",
      "reportHash": "sha256-bd6988c6a71db8619b5759afd545748da7cfe8749e4e0f0132fd091131f16d27",
      "validationHash": "sha256-25b9759df75bc09b9717c320f6ed87536bda0cf211e80977b7fe987678bd7d35",
      "promotionRecordHash": "sha256-30535dadb8daee3b6714ebcb63d4d2455f3a56a7ec1b35e42e84af8f839f7ad6",
      "currentBlockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "querySourceGaps": [
        "mpc"
      ],
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-jn4-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-jn4-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "requiredClosureItems": [
        {
          "id": "mpc-observation-bridge",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "mpc-observation-designation-bridge-receipt",
          "title": "Attach MPC observation/designation bridge receipt",
          "acceptanceCriteria": [
            "Capture the MPC query URL or file path, timestamp, normalized designation bridge, raw hash, normalized hash, units, and parser version.",
            "The candidate source validation fieldCoverage.querySourceGaps must no longer include mpc.",
            "The receipt must be legally reviewable and linked to the exact candidate work order."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jn4-source-intake-report.json evidence/source-candidate-payloads/2026-jn4-source-intake-payload.json",
          "promotionBoundary": "MPC bridge custody can help source-custody promotion only; it is not taxonomy, spectra, resource-composition, or customer-use proof.",
          "closureItemHash": "sha256-31de9f397bb073a33f8d4b4aa0e768bae140151c150c3e3af4ceaf4fd5d91c55"
        },
        {
          "id": "license-or-terms-review",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "source-license-terms-review",
          "title": "Approve source license and terms review",
          "acceptanceCriteria": [
            "Record license/terms source URL, capture timestamp, allowed internal use, redistribution boundary, citation requirement, and reviewer identity.",
            "The candidate source validation blockers must not include an unapproved license or terms review.",
            "The review must explicitly preserve provider-endorsement and customer-report boundaries."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jn4-source-intake-report.json evidence/source-candidate-payloads/2026-jn4-source-intake-payload.json",
          "promotionBoundary": "License approval is a custody/legal gate; it does not promote physics, composition, or economics claims.",
          "closureItemHash": "sha256-06be77dc860069bacc706cd2b0db0e76107bcb3e8a04e246330db5b86919c8e1"
        },
        {
          "id": "candidate-source-reviewer-approval",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "human-reviewer-approval",
          "title": "Approve candidate source review",
          "acceptanceCriteria": [
            "A named reviewer approves the candidate source packet after checking query receipts, hashes, units, timestamps, source-use notes, and candidate identity.",
            "The candidate source validation blockers must not include reviewer approval.",
            "Approval must be scoped to source custody unless composition and customer-use evidence are separately attached."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jn4-source-intake-report.json evidence/source-candidate-payloads/2026-jn4-source-intake-payload.json",
          "promotionBoundary": "Reviewer approval can promote source custody only when all source-custody fields pass; resource and customer-use gates remain separate.",
          "closureItemHash": "sha256-a83632d1c700dcf27543133254a93370d6f58db6f3b77b55843a61e535d0a17f"
        },
        {
          "id": "passed-validation-status",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-source-validation-status",
          "title": "Set validation status to passed only after evidence closure",
          "acceptanceCriteria": [
            "validationStatus must be passed only after required fields, MPC bridge, license review, and reviewer approval are complete.",
            "The generated candidate source promotion ledger must show this work order as sourceCustodyPromotionAllowed.",
            "The promotion record must include a sha256 promotionRecordHash."
          ],
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Passed validation status is not a shortcut; it is accepted only after source-custody evidence and reviewer gates close.",
          "closureItemHash": "sha256-10997988aee7cede2d0cbd9f8a9ad8c2c0b7b9691e3f159aed7264083c2e042c"
        },
        {
          "id": "taxonomy-spectra-or-mission-archive-composition-evidence",
          "gate": "resource-promotion",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-composition-evidence",
          "title": "Attach candidate-specific composition evidence",
          "acceptanceCriteria": [
            "Attach taxonomy, spectra, mission, sample, or archive evidence tied to the candidate or record an explicit no-evidence-found receipt.",
            "Record source, query, timestamp, license, uncertainty, method directness, and hash metadata.",
            "Resource promotion must remain false unless composition evidence is source-backed and reviewer approved."
          ],
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Composition evidence is required before resource or feedstock claims; source custody alone cannot promote resource claims.",
          "closureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43"
        },
        {
          "id": "source-use-clearance",
          "gate": "customer-use",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-source-use-clearance",
          "title": "Approve customer/report source-use clearance",
          "acceptanceCriteria": [
            "Record whether each attached source can be used in customer reports, exported artifacts, screenshots, and investor/research packages.",
            "Capture citation text, redistribution limits, commercial-use boundary, and reviewer approval.",
            "Customer use must remain blocked until this clearance is approved."
          ],
          "verificationCommand": "npm run science:source:clearance && npm run science:packages",
          "promotionBoundary": "Customer source-use clearance affects report eligibility only; it does not validate scientific or engineering claims.",
          "closureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18"
        }
      ],
      "acceptanceGates": {
        "sourceCustodyReadyWhen": "SBDB, CAD, and MPC receipts are attached; required fields are complete; license/terms review is approved; reviewer approval is approved; validationStatus is passed.",
        "resourceReadyWhen": "Source custody is promoted and candidate-specific taxonomy, spectra, mission, sample, or archive composition evidence is approved.",
        "customerReadyWhen": "Resource promotion is complete and source-use clearance permits the candidate evidence in customer-facing report packages."
      },
      "nextCommandSequence": [
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jn4-source-intake-report.json evidence/source-candidate-payloads/2026-jn4-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:report"
      ],
      "promotionBoundary": "This packet is a deterministic closure work instruction. It is not source custody, not resource evidence, not customer-use clearance, and not a verified science claim.",
      "packetHash": "sha256-7701b57f3dbc66ab0ca0f2b87dfff4a7e20bcac6046c973d6a3eeaf395725c0d"
    },
    {
      "id": "candidate-source-closure-packet-2026-jv3",
      "workOrderId": "small-body-source-work-order-2026-jv3",
      "sourceCandidateId": "cad-2026 JV3",
      "designation": "2026 JV3",
      "name": "2026 JV3",
      "queueRank": 9,
      "reviewPriorityScore": 24.51,
      "intakeState": "draft-intake-present-fail-closed",
      "reportPath": "evidence/source-candidate-work-order-reports/generated-candidate-source-draft-intake-report.json",
      "reportHash": "sha256-bd6988c6a71db8619b5759afd545748da7cfe8749e4e0f0132fd091131f16d27",
      "validationHash": "sha256-47b0bd98523e8f119712590a781b27c6153c9f4f7c7987fe3999a4636ab01c76",
      "promotionRecordHash": "sha256-02340feb061034b21ec4786102db1aab0f235b292c75a38ea66600714f75e108",
      "currentBlockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "querySourceGaps": [
        "mpc"
      ],
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-jv3-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-jv3-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "requiredClosureItems": [
        {
          "id": "mpc-observation-bridge",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "mpc-observation-designation-bridge-receipt",
          "title": "Attach MPC observation/designation bridge receipt",
          "acceptanceCriteria": [
            "Capture the MPC query URL or file path, timestamp, normalized designation bridge, raw hash, normalized hash, units, and parser version.",
            "The candidate source validation fieldCoverage.querySourceGaps must no longer include mpc.",
            "The receipt must be legally reviewable and linked to the exact candidate work order."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jv3-source-intake-report.json evidence/source-candidate-payloads/2026-jv3-source-intake-payload.json",
          "promotionBoundary": "MPC bridge custody can help source-custody promotion only; it is not taxonomy, spectra, resource-composition, or customer-use proof.",
          "closureItemHash": "sha256-adc2d4bb966b9b0c0d58b30bc6b816bd33b7101ee23795cd9e2c231d1fa7f471"
        },
        {
          "id": "license-or-terms-review",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "source-license-terms-review",
          "title": "Approve source license and terms review",
          "acceptanceCriteria": [
            "Record license/terms source URL, capture timestamp, allowed internal use, redistribution boundary, citation requirement, and reviewer identity.",
            "The candidate source validation blockers must not include an unapproved license or terms review.",
            "The review must explicitly preserve provider-endorsement and customer-report boundaries."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jv3-source-intake-report.json evidence/source-candidate-payloads/2026-jv3-source-intake-payload.json",
          "promotionBoundary": "License approval is a custody/legal gate; it does not promote physics, composition, or economics claims.",
          "closureItemHash": "sha256-ce2c11338294b9b91f867a42b8c1f34626e36279299eb01c31ead46303bcdc63"
        },
        {
          "id": "candidate-source-reviewer-approval",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "human-reviewer-approval",
          "title": "Approve candidate source review",
          "acceptanceCriteria": [
            "A named reviewer approves the candidate source packet after checking query receipts, hashes, units, timestamps, source-use notes, and candidate identity.",
            "The candidate source validation blockers must not include reviewer approval.",
            "Approval must be scoped to source custody unless composition and customer-use evidence are separately attached."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jv3-source-intake-report.json evidence/source-candidate-payloads/2026-jv3-source-intake-payload.json",
          "promotionBoundary": "Reviewer approval can promote source custody only when all source-custody fields pass; resource and customer-use gates remain separate.",
          "closureItemHash": "sha256-9737fc01a428f99b0647339ef57e60ac65e607c2a72170eb7bd4f5f2a0cdbe0c"
        },
        {
          "id": "passed-validation-status",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-source-validation-status",
          "title": "Set validation status to passed only after evidence closure",
          "acceptanceCriteria": [
            "validationStatus must be passed only after required fields, MPC bridge, license review, and reviewer approval are complete.",
            "The generated candidate source promotion ledger must show this work order as sourceCustodyPromotionAllowed.",
            "The promotion record must include a sha256 promotionRecordHash."
          ],
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Passed validation status is not a shortcut; it is accepted only after source-custody evidence and reviewer gates close.",
          "closureItemHash": "sha256-10997988aee7cede2d0cbd9f8a9ad8c2c0b7b9691e3f159aed7264083c2e042c"
        },
        {
          "id": "taxonomy-spectra-or-mission-archive-composition-evidence",
          "gate": "resource-promotion",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-composition-evidence",
          "title": "Attach candidate-specific composition evidence",
          "acceptanceCriteria": [
            "Attach taxonomy, spectra, mission, sample, or archive evidence tied to the candidate or record an explicit no-evidence-found receipt.",
            "Record source, query, timestamp, license, uncertainty, method directness, and hash metadata.",
            "Resource promotion must remain false unless composition evidence is source-backed and reviewer approved."
          ],
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Composition evidence is required before resource or feedstock claims; source custody alone cannot promote resource claims.",
          "closureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43"
        },
        {
          "id": "source-use-clearance",
          "gate": "customer-use",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-source-use-clearance",
          "title": "Approve customer/report source-use clearance",
          "acceptanceCriteria": [
            "Record whether each attached source can be used in customer reports, exported artifacts, screenshots, and investor/research packages.",
            "Capture citation text, redistribution limits, commercial-use boundary, and reviewer approval.",
            "Customer use must remain blocked until this clearance is approved."
          ],
          "verificationCommand": "npm run science:source:clearance && npm run science:packages",
          "promotionBoundary": "Customer source-use clearance affects report eligibility only; it does not validate scientific or engineering claims.",
          "closureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18"
        }
      ],
      "acceptanceGates": {
        "sourceCustodyReadyWhen": "SBDB, CAD, and MPC receipts are attached; required fields are complete; license/terms review is approved; reviewer approval is approved; validationStatus is passed.",
        "resourceReadyWhen": "Source custody is promoted and candidate-specific taxonomy, spectra, mission, sample, or archive composition evidence is approved.",
        "customerReadyWhen": "Resource promotion is complete and source-use clearance permits the candidate evidence in customer-facing report packages."
      },
      "nextCommandSequence": [
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-jv3-source-intake-report.json evidence/source-candidate-payloads/2026-jv3-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:report"
      ],
      "promotionBoundary": "This packet is a deterministic closure work instruction. It is not source custody, not resource evidence, not customer-use clearance, and not a verified science claim.",
      "packetHash": "sha256-2dc111105cac0e4a2eadba7e79694dced3819549bfbda8fdbdbeeaba97567d89"
    },
    {
      "id": "candidate-source-closure-packet-2026-hz4",
      "workOrderId": "small-body-source-work-order-2026-hz4",
      "sourceCandidateId": "cad-2026 HZ4",
      "designation": "2026 HZ4",
      "name": "2026 HZ4",
      "queueRank": 10,
      "reviewPriorityScore": 24.43,
      "intakeState": "draft-intake-present-fail-closed",
      "reportPath": "evidence/source-candidate-work-order-reports/generated-candidate-source-draft-intake-report.json",
      "reportHash": "sha256-bd6988c6a71db8619b5759afd545748da7cfe8749e4e0f0132fd091131f16d27",
      "validationHash": "sha256-43575c4fcd6a272cf7824bf0891be875e70afc2d81ddf8cfe755b729acd01b20",
      "promotionRecordHash": "sha256-c48056ef5828a68336d06f446971e8a847158f6e236807b013ad2d40e2909195",
      "currentBlockers": [
        "Missing source query receipts: mpc",
        "License or terms review is not approved.",
        "Reviewer approval is not approved.",
        "validationStatus must be passed."
      ],
      "querySourceGaps": [
        "mpc"
      ],
      "requiredIntakeArtifacts": [
        "SBDB object payload with raw and normalized hashes.",
        "CAD candidate payload with raw and normalized hashes.",
        "MPC observation/designation bridge receipt.",
        "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
        "Source-use rights review before any customer-facing export."
      ],
      "outputContract": {
        "payloadPath": "evidence/source-candidate-payloads/2026-hz4-source-intake-payload.json",
        "reportPath": "evidence/source-candidate-reports/2026-hz4-source-intake-report.json",
        "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
        "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
      },
      "sourceCustodyReady": false,
      "resourceReady": false,
      "customerReady": false,
      "requiredClosureItems": [
        {
          "id": "mpc-observation-bridge",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "mpc-observation-designation-bridge-receipt",
          "title": "Attach MPC observation/designation bridge receipt",
          "acceptanceCriteria": [
            "Capture the MPC query URL or file path, timestamp, normalized designation bridge, raw hash, normalized hash, units, and parser version.",
            "The candidate source validation fieldCoverage.querySourceGaps must no longer include mpc.",
            "The receipt must be legally reviewable and linked to the exact candidate work order."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-hz4-source-intake-report.json evidence/source-candidate-payloads/2026-hz4-source-intake-payload.json",
          "promotionBoundary": "MPC bridge custody can help source-custody promotion only; it is not taxonomy, spectra, resource-composition, or customer-use proof.",
          "closureItemHash": "sha256-6a6f08776849331472639a78707dd66fe6c339f78dbd498851e1ee31d2170563"
        },
        {
          "id": "license-or-terms-review",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "source-license-terms-review",
          "title": "Approve source license and terms review",
          "acceptanceCriteria": [
            "Record license/terms source URL, capture timestamp, allowed internal use, redistribution boundary, citation requirement, and reviewer identity.",
            "The candidate source validation blockers must not include an unapproved license or terms review.",
            "The review must explicitly preserve provider-endorsement and customer-report boundaries."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-hz4-source-intake-report.json evidence/source-candidate-payloads/2026-hz4-source-intake-payload.json",
          "promotionBoundary": "License approval is a custody/legal gate; it does not promote physics, composition, or economics claims.",
          "closureItemHash": "sha256-68b3cf18ae6cd24aec6b75036a2322686006d7d8cbe2a3fd4e038b67d1cb325f"
        },
        {
          "id": "candidate-source-reviewer-approval",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "human-reviewer-approval",
          "title": "Approve candidate source review",
          "acceptanceCriteria": [
            "A named reviewer approves the candidate source packet after checking query receipts, hashes, units, timestamps, source-use notes, and candidate identity.",
            "The candidate source validation blockers must not include reviewer approval.",
            "Approval must be scoped to source custody unless composition and customer-use evidence are separately attached."
          ],
          "verificationCommand": "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-hz4-source-intake-report.json evidence/source-candidate-payloads/2026-hz4-source-intake-payload.json",
          "promotionBoundary": "Reviewer approval can promote source custody only when all source-custody fields pass; resource and customer-use gates remain separate.",
          "closureItemHash": "sha256-ddb162a08a78431de5374af929a2f430902115fb619f85fb7eb8cee1a2a97a9c"
        },
        {
          "id": "passed-validation-status",
          "gate": "source-custody",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-source-validation-status",
          "title": "Set validation status to passed only after evidence closure",
          "acceptanceCriteria": [
            "validationStatus must be passed only after required fields, MPC bridge, license review, and reviewer approval are complete.",
            "The generated candidate source promotion ledger must show this work order as sourceCustodyPromotionAllowed.",
            "The promotion record must include a sha256 promotionRecordHash."
          ],
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Passed validation status is not a shortcut; it is accepted only after source-custody evidence and reviewer gates close.",
          "closureItemHash": "sha256-10997988aee7cede2d0cbd9f8a9ad8c2c0b7b9691e3f159aed7264083c2e042c"
        },
        {
          "id": "taxonomy-spectra-or-mission-archive-composition-evidence",
          "gate": "resource-promotion",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-composition-evidence",
          "title": "Attach candidate-specific composition evidence",
          "acceptanceCriteria": [
            "Attach taxonomy, spectra, mission, sample, or archive evidence tied to the candidate or record an explicit no-evidence-found receipt.",
            "Record source, query, timestamp, license, uncertainty, method directness, and hash metadata.",
            "Resource promotion must remain false unless composition evidence is source-backed and reviewer approved."
          ],
          "verificationCommand": "npm run science:smallbody:source-promotion",
          "promotionBoundary": "Composition evidence is required before resource or feedstock claims; source custody alone cannot promote resource claims.",
          "closureItemHash": "sha256-73fb53c184cc55fe1ed071f08619ff0a149a4c07c08a01d275ea88d9c7954d43"
        },
        {
          "id": "source-use-clearance",
          "gate": "customer-use",
          "status": "blocked",
          "requiredEvidenceTypeId": "candidate-source-use-clearance",
          "title": "Approve customer/report source-use clearance",
          "acceptanceCriteria": [
            "Record whether each attached source can be used in customer reports, exported artifacts, screenshots, and investor/research packages.",
            "Capture citation text, redistribution limits, commercial-use boundary, and reviewer approval.",
            "Customer use must remain blocked until this clearance is approved."
          ],
          "verificationCommand": "npm run science:source:clearance && npm run science:packages",
          "promotionBoundary": "Customer source-use clearance affects report eligibility only; it does not validate scientific or engineering claims.",
          "closureItemHash": "sha256-fa8ab15c73992f9c65006870a4e9d94fbe4fdc026ff2571cc7f61f19dc5b1d18"
        }
      ],
      "acceptanceGates": {
        "sourceCustodyReadyWhen": "SBDB, CAD, and MPC receipts are attached; required fields are complete; license/terms review is approved; reviewer approval is approved; validationStatus is passed.",
        "resourceReadyWhen": "Source custody is promoted and candidate-specific taxonomy, spectra, mission, sample, or archive composition evidence is approved.",
        "customerReadyWhen": "Resource promotion is complete and source-use clearance permits the candidate evidence in customer-facing report packages."
      },
      "nextCommandSequence": [
        "npm run science:smallbody:workorder-intake -- --out evidence/source-candidate-reports/2026-hz4-source-intake-report.json evidence/source-candidate-payloads/2026-hz4-source-intake-payload.json",
        "npm run science:smallbody:source-promotion",
        "npm run science:smallbody:closure-packets",
        "npm run science:report"
      ],
      "promotionBoundary": "This packet is a deterministic closure work instruction. It is not source custody, not resource evidence, not customer-use clearance, and not a verified science claim.",
      "packetHash": "sha256-fb5bb6e981af93caaf4fdcfad689868e211b41f5a804eec318002b4dc3135010"
    }
  ],
  "packetHash": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608"
}
;
